import { request, RespError, handleFormatRes } from '../../utils';
import { MULACTION_EXCHANGE_PRIZE } from '../../config/url';
// 需要转成 int 型的 key 数组
const needParseIntKey = [];
// 需要转成 date 型的 key 数组
const needParseDateKey = [];
/**
 * 跨月印花兑换接口
 *
 * 多个兑换活动活动期间只能参与一次，通过该接口完成兑换和限制
 *
 * 接口地址：`/app/promotion/prom_mulaction_exchange_prize.cgi`
 *
 * @param actId 明文兑换活动id
 * @param qualId 密文印花/资格批次id
 * @returns
 */
export async function mulactionExchangePrize({ actId, qualId, }) {
    try {
        // 参数格式化
        const params = {
            t: new Date().getTime(),
            act_id: actId,
            qual_id: qualId,
        };
        // 接口请求
        const result = await request.get(MULACTION_EXCHANGE_PRIZE, { params });
        if (result) {
            // 正常的返回
            if ((result === null || result === void 0 ? void 0 : result.retcode) === '0') {
                const res = handleFormatRes({ result, needParseIntKey, needParseDateKey });
                return res;
            }
            // 状态码错误的返回
            throw new RespError(result.retcode, result.retmsg, result);
        }
        throw result;
    }
    catch (error) {
        throw error;
    }
}
